import { Handle, Position } from '@xyflow/react';
import { useContext } from 'react';
import { useProcessStore } from '../../../store/process-store/process-store.hooks';
import { skyDark } from '../../../styles/design-tokens';
import { ProcessContext } from '../context/process.context';
import { resetProcessTaskDetails } from '../process-graph/process-graph.helpers';
import { EdgeLabel } from './event-edge';

type EdgeLabelNodeProps = {
  id: string;
  data: {
    cost: number;
    cycle_time: number;
    dashed: boolean;
    isRightGraph: boolean;
    percentage: number;
    task_count: number;
    viewType: string;
    weight: number;
    edgeId: string;
  };
};

export const EdgeLabelNode = ({ data, id }: EdgeLabelNodeProps) => {
  const processContext = useContext(ProcessContext);
  const processStore = useProcessStore();
  const { eventScope, setEventScope, rightEventScope, setRightEventScope } = processStore;

  const handleClick = () => {
    resetProcessTaskDetails(processContext, processStore);

    if (data.isRightGraph) {
      setRightEventScope({
        ...rightEventScope,
        selectedEdgeId: data.edgeId,
      });
      setEventScope({
        ...eventScope,
        selectedEdgeId: null,
      });
    } else {
      setEventScope({
        ...eventScope,
        selectedEdgeId: data.edgeId,
      });
      setRightEventScope({
        ...rightEventScope,
        selectedEdgeId: null,
      });
    }
  };
  return (
    <div onClick={handleClick}>
      <Handle type="target" position={Position.Bottom} id={`${id}-target`} />
      <EdgeLabel edgeId={data.edgeId} data={data} color={skyDark} />
      <Handle type="source" position={Position.Top} id={`${id}-source`} />
    </div>
  );
};
